// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__XrPSS","profilePic":"sidebar_profilePic__+ubN5","links":"sidebar_links__I1R1n","socials":"sidebar_socials__dPNBr"};